"use client";

import React, { useMemo, useState } from "react";
import {
  Card,
  Table,
  Button,
  Form,
  Alert,
} from "react-bootstrap";
import {
  useNavigate,
  useParams,
} from "react-router-dom";

const ShoppingCart = () => {
  const { storeCode } = useParams();
  const navigate = useNavigate();

  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem(
          "store_cart"
        ) || "{}"
      );
    } catch {
      return {};
    }
  });

  const [description, setDescription] =
    useState("");

  const storeCart =
    cart[storeCode];

  const items = Object.values(
    storeCart?.items || {}
  );

  const total = useMemo(
    () =>
      items.reduce(
        (sum, item) =>
          sum +
          Number(
            item.product.price ||
              item.product.amount ||
              0
          ) *
            Number(item.quantity),
        0
      ),
    [items]
  );

  const updateCart = (itemsMap) => {
    const next = {
      ...cart,
      [storeCode]: {
        ...storeCart,
        items: itemsMap,
      },
    };

    setCart(next);

    localStorage.setItem(
      "store_cart",
      JSON.stringify(next)
    );
  };

  const changeQuantity = (
    item,
    amount
  ) => {
    const key =
      item.product.code ||
      item.product.storeProductCode ||
      item.product.id;

    const current =
      storeCart.items[key];

    const quantity =
      current.quantity + amount;

    const nextItems = {
      ...storeCart.items,
    };

    if (quantity <= 0) {
      delete nextItems[key];
    } else {
      nextItems[key] = {
        ...current,
        quantity,
      };
    }

    updateCart(nextItems);
  };

  if (items.length === 0) {
    return (
      <Alert variant="info">
        سبد خرید شما خالی است.
        <div className="mt-3">
          <Button
            onClick={() =>
              navigate(
                `/user/stores/${storeCode}/products`
              )
            }
          >
            بازگشت به محصولات
          </Button>
        </div>
      </Alert>
    );
  }

  return (
    <Card className="border-0 rounded-3">
      <Card.Body className="p-4">
        <h3 className="mb-4">
          سبد خرید
        </h3>

        <div className="table-responsive">
          <Table
            hover
            responsive
            className="align-middle"
          >
            <thead>
              <tr>
                <th>محصول</th>
                <th>قیمت</th>
                <th>تعداد</th>
                <th>جمع</th>
              </tr>
            </thead>

            <tbody>
              {items.map((item) => {
                const product =
                  item.product;

                const price =
                  Number(
                    product.price ||
                      product.amount ||
                      0
                  );

                return (
                  <tr
                    key={
                      product.code ||
                      product.storeProductCode ||
                      product.id
                    }
                  >
                    <td>
                      {product.name ||
                        product.product?.title}
                    </td>

                    <td>
                      {price.toLocaleString(
                        "fa-IR"
                      )}{" "}
                      تومان
                    </td>

                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() =>
                            changeQuantity(
                              item,
                              -1
                            )
                          }
                        >
                          −
                        </Button>

                        <strong>
                          {item.quantity}
                        </strong>

                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() =>
                            changeQuantity(
                              item,
                              1
                            )
                          }
                        >
                          +
                        </Button>
                      </div>
                    </td>

                    <td>
                      {(
                        price *
                        item.quantity
                      ).toLocaleString(
                        "fa-IR"
                      )}{" "}
                      تومان
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        <Form.Group className="mb-4 mt-4">
          <Form.Label>
            توضیحات سفارش
          </Form.Label>

          <Form.Control
            as="textarea"
            rows={4}
            value={description}
            onChange={(e) =>
              setDescription(
                e.target.value
              )
            }
            placeholder="مثلاً بدون پیاز..."
          />
        </Form.Group>

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div>
            <span className="text-secondary">
              مبلغ کل
            </span>

            <h3 className="mb-0">
              {total.toLocaleString(
                "fa-IR"
              )}{" "}
              تومان
            </h3>
          </div>

          <Button
            variant="primary"
            size="lg"
            onClick={() =>
              navigate(
                `/user/stores/${storeCode}/checkout`,
                {
                  state: {
                    description,
                  },
                }
              )
            }
          >
            ادامه و ثبت سفارش
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ShoppingCart;